import { createIrisApiClient, basePaths } from '@/api/clients/iris/irisapi'

const irisApiClient = createIrisApiClient(basePaths.iris)
const baseFilterPath = 'filter'

/**
 * Fetches filter metadata. Can be filtered by inspection instance.
 * @param params - Optional parameters to filter the metadata.
 * @param params.inspectionInstance - The UUID of the inspection instance.
 */
const getFilterMetaData = (params?: { inspectionInstance?: string | null }) => {
  let url = `/${baseFilterPath}/metadata/`
  if (params?.inspectionInstance) {
    url += `?inspectionInstance=${params.inspectionInstance}`
  }
  return irisApiClient.get(url)
}

export { getFilterMetaData }
